import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Portfolio Analysis'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGet: build.query<
        GetLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGetApiResponse,
        GetLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/linked_energy_groups/${queryArg.accountId}`,
        }),
        providesTags: ['Portfolio Analysis'],
      }),
      getPaMetersPortfolioMetersAnalysisTypeAccountIdGet: build.query<
        GetPaMetersPortfolioMetersAnalysisTypeAccountIdGetApiResponse,
        GetPaMetersPortfolioMetersAnalysisTypeAccountIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/portfolio_meters/${queryArg.analysisType}/${queryArg.accountId}`,
        }),
        providesTags: ['Portfolio Analysis'],
      }),
      getSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGet:
        build.query<
          GetSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGetApiResponse,
          GetSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/portfolio_meters/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
          }),
          providesTags: ['Portfolio Analysis'],
        }),
      setAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPut:
        build.mutation<
          SetAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPutApiResponse,
          SetAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPutApiArg
        >({
          query: (queryArg) => ({
            url: `/meter_address/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
            method: 'PUT',
            params: {
              postal_code: queryArg.postalCode,
              street: queryArg.street,
              building_number: queryArg.buildingNumber,
              city: queryArg.city,
              matrikel_key: queryArg.matrikelKey,
              address_suffix: queryArg.addressSuffix,
            },
          }),
          invalidatesTags: ['Portfolio Analysis'],
        }),
      removeAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDelete:
        build.mutation<
          RemoveAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDeleteApiResponse,
          RemoveAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDeleteApiArg
        >({
          query: (queryArg) => ({
            url: `/meter_address/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['Portfolio Analysis'],
        }),
      setDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPut:
        build.mutation<
          SetDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPutApiResponse,
          SetDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPutApiArg
        >({
          query: (queryArg) => ({
            url: `/meter_display_name/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
            method: 'PUT',
            params: {
              display_name: queryArg.displayName,
            },
          }),
          invalidatesTags: ['Portfolio Analysis'],
        }),
      getOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGet: build.query<
        GetOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGetApiResponse,
        GetOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/occupancy/${queryArg.analysisType}/${queryArg.recalcAccountId}/${queryArg.meterId}`,
        }),
        providesTags: ['Portfolio Analysis'],
      }),
      setManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPut:
        build.mutation<
          SetManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPutApiResponse,
          SetManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPutApiArg
        >({
          query: (queryArg) => ({
            url: `/manual_occupancy/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
            method: 'PUT',
            body: queryArg.occupancy,
          }),
          invalidatesTags: ['Portfolio Analysis'],
        }),
      setMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPut:
        build.mutation<
          SetMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPutApiResponse,
          SetMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPutApiArg
        >({
          query: (queryArg) => ({
            url: `/meter_utility_provider/${queryArg.analysisType}/${queryArg.accountId}/${queryArg.meterId}`,
            method: 'PUT',
            params: {
              utility_provider_id: queryArg.utilityProviderId,
            },
          }),
          invalidatesTags: ['Portfolio Analysis'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type GetLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGetApiResponse =
  /** status 200 Successful Response */ LinkedEnergyGroupsOutput;
export type GetLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGetApiArg = {
  /** The ReCalc account id to get linked energy groups for. */
  accountId: number;
};
export type GetPaMetersPortfolioMetersAnalysisTypeAccountIdGetApiResponse =
  /** status 200 Successful Response */ (
    | PortfolioAnalysisMetersOutput
    | PortfolioAnalysisPowerMetersOutput
  )[];
export type GetPaMetersPortfolioMetersAnalysisTypeAccountIdGetApiArg = {
  /** The ReCalc account id to get the meters for. */
  accountId: number;
  /** The type of analysis to perform. */
  analysisType: AnalysisType;
};
export type GetSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGetApiResponse =
  /** status 200 Successful Response */
    | PortfolioAnalysisMetersOutput
    | PortfolioAnalysisPowerMetersOutput;
export type GetSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGetApiArg =
  {
    /** The ReCalc account id to get the meters for. */
    accountId: number;
    /** The type of analysis to perform. */
    analysisType: AnalysisType;
    /** The meter id to get the occupancy for. Either a recalc unit id if analysis type is water or heat, or a metering point id if analysis type is power.. */
    meterId: number;
  };
export type SetAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPutApiResponse =
  /** status 200 Successful Response */ number;
export type SetAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPutApiArg =
  {
    /** The type of analysis that the meter is used for. */
    analysisType: AnalysisType;
    /** The ReCalc account id to set the address info for. */
    accountId: number;
    /** The meter id to set the address info for. */
    meterId: number;
    /** The zip code of the address to update. */
    postalCode: number;
    /** The street name of the address to update. */
    street: string;
    /** The street number of the address to update. */
    buildingNumber: string;
    /** The city of the address to update. */
    city?: string | null;
    /** The matrikel key to associate with the meter. */
    matrikelKey?: string | null;
    /** Optional address suffix for floor number or apartment identifier (e.g., '3. Th', '2. sal', '2.3'). */
    addressSuffix?: string | null;
  };
export type RemoveAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDeleteApiResponse =
  /** status 200 Successful Response */ number;
export type RemoveAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDeleteApiArg =
  {
    /** The type of analysis that the meter is used for. */
    analysisType: AnalysisType;
    /** The ReCalc account id to remove the address info for. */
    accountId: number;
    /** The meter id to remove the address info for. */
    meterId: number;
  };
export type SetDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPutApiResponse =
  /** status 200 Successful Response */ number;
export type SetDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPutApiArg =
  {
    /** The type of analysis that the meter is used for. */
    analysisType: AnalysisType;
    /** The ReCalc account id to set the address info for. */
    accountId: number;
    /** The meter id to set the address info for. */
    meterId: number;
    /** The display name to set for the meter. */
    displayName: string;
  };
export type GetOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGetApiResponse =
  /** status 200 Successful Response */ PortfolioAnalysisOccupancyOutput;
export type GetOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGetApiArg = {
  /** The ReCalc account id to get the meters for. */
  recalcAccountId: number;
  /** The type of analysis to perform. */
  analysisType: AnalysisType;
  /** The meter id to get the occupancy for. Either a recalc unit id if analysis type is water or heat, or a metering point id if analysis type is power.. */
  meterId: number;
};
export type SetManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPutApiResponse =
  /** status 200 Successful Response */ number;
export type SetManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPutApiArg =
  {
    /** The meter id to set the daytime interval for. Either a recalc unit id if analysis type is water or heat, or a metering point id if analysis type is power.. */
    meterId: number;
    /** The ReCalc account id to set the daytime interval for. */
    accountId: number;
    /** The type of analysis to perform. */
    analysisType: AnalysisType;
    occupancy: PortfolioAnalysisOccupancy | null;
  };
export type SetMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPutApiResponse =
  /** status 200 Successful Response */ number;
export type SetMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPutApiArg =
  {
    /** The type of analysis that the meter is used for (must be 'heat' or 'water') */
    analysisType: AnalysisType;
    /** The ReCalc account id for the meter. */
    accountId: number;
    /** The meter id to set the utility provider for. */
    meterId: number;
    /** The 4-digit utility provider ID (1000+ for water, 5000+ for heat) */
    utilityProviderId: string;
  };
export type LinkedMeter = {
  /** The meter id. */
  meterId: string;
  /** The unit id. */
  unitId: number;
  /** The unit type input id. */
  unitTypeInputId: number;
  /** The aggregate type. */
  aggregateType: string;
  /** The data type. */
  dataType: string;
};
export type LinkedEnergyGroup = {
  /** The energy group id. */
  energyGroupId: number;
  /** The type of energy group. */
  type: string;
  /** The name of the energy group. */
  name: string;
  /** The list of linked meters. */
  linkedMeters: LinkedMeter[];
};
export type MatrikelLinkedEnergyGroups = {
  /** The matrikel key. */
  MatrikelKey: string;
  /** The list of linked energy groups. */
  LinkedEnergyGroups: LinkedEnergyGroup[];
  /** The BFE number. */
  BFENummer?: number | null;
};
export type LinkedEnergyGroupsOutput = {
  /** The list of matrikel linked energy groups. */
  LinkedEnergyGroups: MatrikelLinkedEnergyGroups[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type PortfolioAnalysisMetersOutput = {
  /** The address of the meter. */
  Address: string | number;
  /** The name of the meter. */
  Name: string;
  /** The display name of the meter. */
  DisplayName?: string | null;
  /** The unit id for the meter. */
  UnitId: number;
  /** The aggregate type for the meter data. */
  aggregate_type: string;
  /** The data type for the meter data. */
  data_type: string;
  /** The unit type input id for the meter. */
  unit_type_input_id: number;
  /** If the Matrikel/BBR integration was successful for the meter. */
  MatrikelIntegrationSuccess?: boolean | null;
  /** The BFE number of the meter. */
  BFENummer?: number | null;
  /** The building number of the meter. */
  BuildingNumber?: string | null;
  /** The property type of the meter. */
  Ejendomstype?: string | null;
  /** The owner code of the meter. */
  EjerlavKode?: number | null;
  /** The owner name of the meter. */
  EjerlavNavn?: string | null;
  /** The municipality code of the meter. */
  KommuneKode?: number | null;
  /** The matrikel number of the meter. */
  MatrikelNr?: string | null;
  /** The matrikel key of the meter. */
  MatrikelKey?: string | null;
  /** The postal code of the meter. */
  PostalCode?: number | null;
  /** The street of the meter. */
  Street?: string | null;
  /** The city of the meter. */
  City?: string | null;
  /** If the meter is synced. Meaning that the calculations are performed after the meter was last changed. */
  meter_in_sync?: boolean | null;
  /** If the meter has calculated occupancy data or not. */
  HasCalculatedOccupancy?: boolean | null;
  /** If the meter has manually set occupancy data or not. */
  HasManualOccupancy?: boolean | null;
  /** The utility provider id associated with the meter. */
  UtilityProviderId?: string | null;
  /** The utility provider name associated with the meter. */
  UtilityProviderName?: string | null;
};
export type PortfolioAnalysisPowerMetersOutput = {
  /** The account id of the subscription. */
  AccountId: number;
  /** The account name of the subscription. */
  AccountName?: string | null;
  /** The display name of the meter. */
  DisplayName?: string | null;
  /** If the subscription is active. */
  Active: boolean;
  /** The address of the meter. */
  Address?: string | null;
  /** If the Matrikel integration was successful for the meter. */
  MatrikelIntegrationSuccess?: boolean | null;
  /** The BFE number of the meter. */
  BFENummer?: number | null;
  /** The building number of the meter. */
  BuildingNumber?: string | null;
  /** The city of the meter. */
  City?: string | null;
  /** The CVR number of the customer. */
  CustomerCVR?: number | null;
  /** The owner code of the meter. */
  EjerlavKode?: number | null;
  /** The location code of the meter (either DK1 or DK2). */
  LocationCode?: string | null;
  /** The matrikel number of the meter. */
  MatrikelNr?: string | null;
  /** The matrikel key of the meter. */
  MatrikelKey?: string | null;
  /** The metering point id of the meter. */
  MeteringPointId?: string | null;
  /** The postal code of the meter. */
  PostalCode?: number | null;
  /** The aggregate type for the ReMoni data. Supported types: 'Minutes5', 'Hour'. */
  ReMoniAggregateType: string;
  /** The data type for the ReMoni data. Supported types: 'power', 'power-consumption'. */
  ReMoniDataType: string;
  /** The unit id for the ReMoni data. */
  ReMoniUnitId: number;
  /** The unit type input id for the ReMoni data. */
  ReMoniUnitTypeInputId: number;
  /** The street of the meter. */
  Street?: string | null;
  /** The occupancy end time for the daytime period. */
  OccupancyDaytimeEnd?: number | null;
  /** The occupancy start time for the daytime period. */
  OccupancyDaytimeStart?: number | null;
  /** The manually set end of the daytime period. */
  ManualDaytimeEnd?: number | null;
  /** The manually set start of the daytime period. */
  ManualDaytimeStart?: number | null;
  /** If the meter is synced. Meaning that the calculations are performed after the meter was last changed. */
  meter_in_sync?: boolean | null;
};
export type AnalysisType = 'power' | 'heat' | 'water';
export type OccupancyDay = {
  /** If there is occupancy on this day. */
  occupancy: boolean;
  /** The start time of occupancy. */
  start_time?: number | null;
  /** The end time of occupancy. */
  end_time?: number | null;
};
export type PortfolioAnalysisOccupancy = {
  /** Occupancy information for Monday. */
  Monday: OccupancyDay;
  /** Occupancy information for Tuesday. */
  Tuesday: OccupancyDay;
  /** Occupancy information for Wednesday. */
  Wednesday: OccupancyDay;
  /** Occupancy information for Thursday. */
  Thursday: OccupancyDay;
  /** Occupancy information for Friday. */
  Friday: OccupancyDay;
  /** Occupancy information for Saturday. */
  Saturday: OccupancyDay;
  /** Occupancy information for Sunday. */
  Sunday: OccupancyDay;
};
export type PortfolioAnalysisOccupancyOutput = {
  /** The default occupancy information for the meter. */
  DefaultOccupancy: PortfolioAnalysisOccupancy;
  /** The calculated occupancy information for the meter based on the energy data. */
  CalculatedOccupancy?: PortfolioAnalysisOccupancy | null;
  /** The manual occupancy information for the portfolio set by the user. */
  ManualOccupancy?: PortfolioAnalysisOccupancy | null;
};
export const {
  useGetLinkedEnergyGroupsLinkedEnergyGroupsAccountIdGetQuery,
  useGetPaMetersPortfolioMetersAnalysisTypeAccountIdGetQuery,
  useGetSinglePaMeterPortfolioMetersAnalysisTypeAccountIdMeterIdGetQuery,
  useSetAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdPutMutation,
  useRemoveAddressInfoForMeterMeterAddressAnalysisTypeAccountIdMeterIdDeleteMutation,
  useSetDisplayNameForMeterMeterDisplayNameAnalysisTypeAccountIdMeterIdPutMutation,
  useGetOccupancyOccupancyAnalysisTypeRecalcAccountIdMeterIdGetQuery,
  useSetManualOccupancyForMeterManualOccupancyAnalysisTypeAccountIdMeterIdPutMutation,
  useSetMeterUtilityProviderMeterUtilityProviderAnalysisTypeAccountIdMeterIdPutMutation,
} = injectedRtkApi;
